if (!customElements.get('product-info')) {
  console.log("you are changing the variant.", "product-info");
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }
      
      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
          if (!this.contains(event.target)) return;
      
          this.resetProductFormState();
          const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
          this.pendingRequestUrl = productUrl;
          const shouldSwapProduct = this.dataset.url !== productUrl;
          const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
      
          this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
            targetId: target.id,
            callback: shouldSwapProduct
              ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
              : this.handleUpdateProductInfo(productUrl),
          });
      }


      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();
      
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);
      
          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
      
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
      
        };
      }


      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          console.log("main-url update")
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id, variant?.featured_media?.alt);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          // const sizeVariantWrap = this.querySelectorAll(".option-Size-padding label[data-variant-available='true']");
          // const colorVariantWrap = this.querySelectorAll(".option-Color-padding input[type='radio']");
          
          // colorVariantWrap.forEach((colorInput) => {
          //   colorInput.addEventListener("click", function () {
          //     console.log("Clicked color:", this.value);
          //     for (let input of sizeVariantWrap) {
          //       if (!input.disabled) {
          //         input.click(); 
          //         console.log("Clicked size input:", input);
          //         break;
          //       }
          //     }
          //   });
          // });


          
          
          // const colorVariantWrap = document.querySelectorAll(".option-Color-padding input[type='radio']")
          // colorVariantWrap.forEach(function (colorInput) {
          //     const sizeVariantWrap = document.querySelectorAll(".option-Size-padding label[data-variant-available='true']")
          //     sizeVariantWrap.forEach(function (sizeInput) {
          //         console.log("Size Label", sizeInput)
          //     })
          // })

          console.log("You are changing the variant:", variant);
         const customSizeChart = document.querySelector('.size-guide-overlay');
          if(customSizeChart){
            console.log("running size guide wrap.")
            initializeSizeGuideDrawer()
          }
          // const savedAmountSpan = document.querySelector('.price__badge-sale .custom-saved-amount');
          // const saleBadge = document.querySelector('.sale-badge-text-wrap');
          
          // console.log("Saved Amount Wrap:", savedAmountSpan);
          // console.log("Sale Badge:", saleBadge);
          
          // if (!savedAmountSpan) {
          //   console.error("The element '.price__badge-sale .custom-saved-amount' does not exist in the DOM.");
          //   return;
          // }
          
          // if (!saleBadge) {
          //   console.error("The element '.sale-badge-text-wrap' does not exist in the DOM.");
          //   return;
          // }
          
          // if (!variant || variant.compare_at_price === undefined || variant.price === undefined) {
          //   console.error("Invalid variant data:", variant);
          //   return;
          // }
          
          // if (variant.compare_at_price > variant.price) {
          //   console.log("compare_at_price is greater than price.");
          
          //   if (saleBadge) {
          //     saleBadge.style.display = 'block';
          //   }
          
          //   const savedAmount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          //   savedAmountSpan.innerHTML = `${savedAmount}% OFF`;
          //   console.log("Saved Amount:", savedAmount);
          
          // } else {
          //   console.log("compare_at_price is not greater than price.");
          
          //   savedAmountSpan.textContent = '';
          
          //   if (saleBadge) {
          //     saleBadge.style.display = 'none';
          //   }
          // }



          // console.log("you are changing the variant.", variant);
          // const savedAmountSpan = document.querySelector('.price__badge-sale .custom-saved-amount');
          // console.log("Saved Amount Wrap", savedAmountSpan);
          // if (variant.compare_at_price > variant.price) {
          //   const savedAmount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          //   savedAmountSpan.innerHTML = `${savedAmount}% OFF`;
          //   console.log(savedAmount);
          // } 
          // else {
          //   savedAmountSpan.textContent = '';
          // }


          
          const stickyCart = document.querySelector('.sticky-atc-bar-main-wrap');          
         
          if(stickyCart){
            const stickyVariantTitle = stickyCart.querySelector('.sticky-atc-variant-title');
            const stickyVariantPrice = stickyCart.querySelector('.sticky-atc-variant-price');
            const stickyAtcButton = stickyCart.querySelector('.custom-sticky-atc-button');
            const stickyVariantImage = stickyCart.querySelector('.sticky-atc-variant-image img');
            const sizeSelectedValue = document.querySelector('.variant-selected-value-wrap.size-selected-value')
            if(stickyVariantTitle){
              stickyVariantTitle.innerHTML = variant.title;
            }
            
            if(stickyVariantPrice){
              const priceSource = html.getElementById(`price-${this.sectionId}`)
              stickyVariantPrice.innerHTML = priceSource.innerHTML;
            }

             if (variant.available){
              if(sizeSelectedValue){
                sizeSelectedValue.style.display = 'inline'
              } 
             }else{
                if(sizeSelectedValue){
                sizeSelectedValue.style.display = 'none'
              } 
             }
            
              if (stickyAtcButton) {
                if (variant.available) {
                  stickyAtcButton.removeAttribute('disabled');
                  stickyAtcButton.innerHTML = 'Add To Bag';
                } else {
                  stickyAtcButton.setAttribute('disabled', 'disabled');
                  stickyAtcButton.innerHTML = 'Sold Out';
                }
              }
            
             if(stickyVariantImage){
              stickyVariantImage.src = variant?.featured_image?.src;
            }
          }
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

         updateURL(url, variantId) {
        if(document.body.classList.contains('product')){
          this.querySelector('share-button')?.updateUrl(
            `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
          );
        }
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }



      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId, variantFeaturedMediaAlt) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        } 
        else {
          function handleize(input) {
            return input
              .toLowerCase()                   
              .replace(/\s+/g, '-')             
              .replace(/[^a-z0-9-]/g, '')       
              .replace(/^-+|-+$/g, '');
          }
          const handleizedFeaturedMediaAlt = handleize(variantFeaturedMediaAlt);
          const customMediaGallerySource = this.querySelector('.swiper.product-images-container .swiper-wrapper');
          const customMediaThumbnailGallerySource = this.querySelector('.product-thumbnails.swiper-thumbs .swiper-wrapper');
          const targetMediaGallerySource = `${this.dataset.section}-${variantFeaturedMediaId}`;
          
          if (customMediaGallerySource && customMediaGallerySource.children.length > 0) {
            const sourceGallerySlides = Array.from(this.querySelectorAll('.hidden-product-gallery-wrap .gallery-slide'))
            const sourceThumbnailGallerySlides = Array.from(this.querySelectorAll('.hidden-product-thumbnail-wrap .thumbnail-slide'))

            const filteredGallerySlides = sourceGallerySlides.filter(slide => 
              slide.getAttribute('data-media-alt') === handleizedFeaturedMediaAlt
            );

            const filteredThumnailsGallerySlides = sourceThumbnailGallerySlides.filter(slide => 
              slide.getAttribute('data-media-alt') === handleizedFeaturedMediaAlt
            );
            
            const swiperEl = this.querySelector('.swiper');
            const swiperElThumbs = this.querySelector('.swiper-thumbs.product-thumbnails');
            if(document.body.classList.contains('product')){
              swiperEl.swiper.destroy(true, true);
              Fancybox.destroy();
            }
            customMediaGallerySource.innerHTML = '';
            customMediaThumbnailGallerySource.innerHTML = '';
            
            if (filteredGallerySlides.length > 0) {
              customMediaGallerySource.innerHTML = filteredGallerySlides.map(slide => slide.outerHTML).join('');
            }

            if (filteredThumnailsGallerySlides.length > 0) {
              customMediaThumbnailGallerySource.innerHTML = filteredThumnailsGallerySlides.map(slide => slide.outerHTML).join('');
            }
            if(document.body.classList.contains('product')){
              Fancybox.bind('[data-fancybox="gallery"]:not(.hidden-product-gallery-wrap a)', {
              Hash: false,
              Thumbs: false,
              compact: false,
              contentClick: "toggleCover",
              wheel: "slide",
              idleTime: 2,
              Images: {
                Panzoom: {
                  panMode: "mousemove",
                  mouseMoveFactor: 1.1,
                  mouseMoveFriction: 0.12,
                  zoom: true,        
                  maxScale: 5,
                },
              },
              Toolbar: {
                display: {
                  left: [],
                  middle: ["prev", "close", "next"],
                  right: ["next"],
                }
              },
              keyboard: {
                Escape: "close",
                Delete: "close",
                Backspace: "close",
                PageUp: "next",
                PageDown: "prev",
                ArrowUp: "prev",
                ArrowDown: "next",
                ArrowRight: "next",
                ArrowLeft: "prev",
              },              
            });
            }
            const customThumbsSwiper = new Swiper(swiperElThumbs, {
              spaceBetween: 10,
              slidesPerView: 4,
              direction: 'vertical',
              freeMode: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
              slideToClickedSlide: true,
            });
            new Swiper(swiperEl, {             
              effect: 'slide',
              spaceBetween: 10,
              speed: 500,
              slidesPerView: 1,
              freeMode: false,
              loop: true,
              slidesPerView: 1,
              // mousewheel: true,
              mousewheel: {
                releaseOnEdges: true,
                forceToAxis: true,
              },              
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
              thumbs: {
                swiper: customThumbsSwiper,
              },
             breakpoints: {
                768: {
                  direction: 'horizontal',
                   loop: true,
                   slidesPerView: 1,
                   spaceBetween: 30,
                },
                769: {
                  direction: 'vertical',
                  loop: false,
                }
              },
            });
          } else {
            console.error('Custom media gallery source is either missing or empty.');
          }          
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
